import IRetailerVehicleAvailability from '@/models/test-drive/interfaces/retailer-vehicle-availability.d';
import IRetailerState from './interfaces/retailer-state.d';

export default class RetailerState implements IRetailerState {
  public retailersWithAvailability: IRetailerVehicleAvailability[] = [];

  public selectedRetailer: IRetailerVehicleAvailability | null = null;
}
